import * as React from 'react'
import {
  LearnModeSectionEmptyRow,
  LearnMoreSectionContainer,
  LearnMoreSectionHeader,
  LearnMoreSectionHeaderTitle,
  LearnMoreSectionRow
} from './LearnMoreSection.elements'
import {ContentCard} from "@components/Cards/ContentCard";

export type LearnMoreSectionProps = {
  title: string
  data: any[]
}

export const LearnMoreSection: React.FunctionComponent<LearnMoreSectionProps> = ({title, data}) => (
  <LearnMoreSectionContainer>
    <LearnMoreSectionHeader>
      <LearnMoreSectionHeaderTitle dangerouslySetInnerHTML={{__html: title}}/>
    </LearnMoreSectionHeader>
    <LearnMoreSectionRow>
      <LearnModeSectionEmptyRow />
      {data.map(d => (
        <li key={d.title}>
          <ContentCard
            imageUrl={d.imageUrl}
            title={d.title}
            link={d.link}
          />
        </li>
      ))}
      <LearnModeSectionEmptyRow />
    </LearnMoreSectionRow>
  </LearnMoreSectionContainer>
)
